import { SingleDatePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import moment from "moment";

import React, { Component } from "react";

class DayPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focused: false
    };
  }

  render() {
    const { input: { value, onChange } } = this.props;
    return (
      <SingleDatePicker
        numberOfMonths={1}
        date={value}
        onDateChange={date => onChange(date)}
        focused={this.state.focused}
        onFocusChange={({ focused }) => this.setState({ focused })}
      />
    );
  }
}

export default DayPicker;



// WEBPACK FOOTER //
// ./src/components/Booking/FormContainer/dayPicker.jsx